import { render } from "./Detail.vue?vue&type=template&id=019e9cd4&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=019e9cd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-019e9cd4"

export default script